import { useEffect } from 'react'
import { Outlet } from 'react-router'

import TopScrollButton from '@wwt/features/top-scroll'

import { ModalManager } from '@wwt/core/modals'
import { localStorageAdapter, setStorage } from '@wwt/shared/utils/storage'
import { Footer } from '@wwt/widgets/footer'

import { ErrorBoundary } from '@/features/ErrorBoundary'

import { ScrollToTop } from '../ScrollToTop'
import { AppHeader } from './AppHeader.tsx'
import { AppToaster } from './AppToaster.tsx'
import { useCookies } from './cookies/useCookies.tsx'
import { useNotificationPopups } from './notifications/useNotificationPopups.tsx'
import { useNps } from './nps/useNps.ts'
import { useTutorial } from './tutorial/useTutorial.ts'

// TODO: Rename to RootLayout
// TODO: Create separate layout for admin pages
export const App = () => {
	useNps()
	useCookies()
	useNotificationPopups()
	const { initTutorial } = useTutorial()

	useEffect(() => {
		initTutorial()

		setStorage(localStorageAdapter())
	}, [])

	// ErrorBoundary should be in App because if we move it to main.ts errors
	// will be catched by react-router instead of this custom boundary
	return (
		<ErrorBoundary>
			<div className="mx-auto flex min-h-screen flex-col items-center font-sans">
				<AppToaster>
					<AppHeader />
					<Outlet />
					<Footer />
					<ScrollToTop />
					<TopScrollButton />

					<ModalManager />
				</AppToaster>
			</div>
		</ErrorBoundary>
	)
}
